// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S9OV","col":"styles_col__3M91V"};